import { Navigate } from "react-router-dom";
import { MODULE_INFO } from "@/auth/appModules";
import { AccessMessage } from "@/auth/RequireModule";
import { useAuth } from "@/auth/useAuth";

/**
 * First page after login: the waiting room without a role, otherwise the
 * first page the user's access groups allow (or the admin panel).
 */
export const SmartRedirect = () => {
  const { isPending, modules, isPlatformAdmin } = useAuth();

  if (isPending) return <Navigate to="/pending" replace />;
  if (modules.length > 0) return <Navigate to={MODULE_INFO[modules[0]].path} replace />;
  if (isPlatformAdmin) return <Navigate to="/admin" replace />;
  return (
    <AccessMessage title="No pages assigned yet">
      <p>
        Your account is approved, but no pages have been assigned to it yet. Please contact your
        MDF administrator.
      </p>
    </AccessMessage>
  );
};

export default SmartRedirect;
